<template>
  <section>
    <b-container fluid>
      <b-row class="justify-content-center services">
        <b-col
          cols="11"
          sm="10"
          md="9"
          xl="8"
          class="flex-column justify-content-center d-flex"
        >
          <!-- 关于我们 -->
          <div class="jian">
            <v-com_title :msg="hTitle[0]"></v-com_title>

            <b-container fluid>
              <b-row class="justify-content-center fuwu-wrap">
                <b-col
                  cols="12"
                  md="11"
                  lg="10"
                  xl="9"
                  class="flex-column justify-content-center d-flex"
                >
                  <div class="tabs-box">
                    <b-tabs content-class="mt-3" justified>
                      <b-tab
                        v-for="(item, index) in tabsList"
                        :title="item"
                        title-item-class="item-class"
                        @click="tabsContent(index)"
                        :key="index"
                      ></b-tab>
                    </b-tabs>
                  </div>
                </b-col>
              </b-row>
            </b-container>

            <b-container fluid>
              <b-row class="justify-content-center fuwu">
                <b-col
                  cols="12"
                  md="10"
                  lg="6"
                  class="flex-column justify-content-center d-flex"
                >
                  <img
                    :src="contentList[indexTab].img"
                    alt=""
                    class="bg-item"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="10"
                  lg="6"
                  class="flex-column justify-content-center d-flex"
                >
                  <div class="right_c">
                    <div
                      class="item_c_item"
                      v-for="val in contentList[indexTab].itemList"
                      :key="val.id"
                    >
                      <img :src="val.icon" alt="" /><span>{{ val.name }}</span>
                    </div>
                    <div class="btns" style="display: none">
                      <span style="cursor: not-allowed">立即体验</span>
                      <span style="cursor: no-drop" @click="goPage()"
                        >了解详情</span
                      >
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Com_title from "../com-title";
export default {
  components: {
    "v-com_title": Com_title,
  },
  data() {
    return {
      hTitle: ["服务案例"],
      tabPosition: "top",
      tabsList: ["统一服务平台(USP)", "手册规范化管理系统", "航数聚"],
      contentList: [],
      indexTab: 0,
    };
  },
  watch: {},
  created() {
    this.getContentList();
  },
  mounted() {},
  methods: {
    goPage() {
      // this.$router.push({
      //     path:'/e-gov/wisdom-gov'
      //   })
    },
    tabsContent(index) {
      console.log("21323", index);
      this.indexTab = index;
    },
    // 获取服务案例的数据
    getContentList() {
      this.contentList = [
        {
          id: "01",
          img: require("@/assets/images/index/s_fwal/usp/services_bg.png"),
          itemList: [
            {
              id: "011",
              name: "首次向企业用户开放数据的信息化服务平台",
              icon: require("@/assets/images/index/s_fwal/usp/service_icon1.png"),
            },
            {
              id: "012",
              name: "4个主题域、167个信息项服务",
              icon: require("@/assets/images/index/s_fwal/usp/service_icon2.png"),
            },
            {
              id: "013",
              name: "方便快捷、界面清晰的查询环境",
              icon: require("@/assets/images/index/s_fwal/usp/service_icon3.png"),
            },
            {
              id: "014",
              name: "token查询方式和IP白名单访问保证数据安全",
              icon: require("@/assets/images/index/s_fwal/usp/service_icon4.png"),
            },
          ],
        },
        {
          id: "02",
          img: require("@/assets/images/index/s_fwal/scgf/services_bg.png"),
          itemList: [
            {
              id: "021",
              name: "支持内容导入、结构化编辑、多终端查询",
              icon: require("@/assets/images/index/s_fwal/scgf/service_icon1.png"),
            },
            {
              id: "022",
              name: "新旧版本留痕管理功能",
              icon: require("@/assets/images/index/s_fwal/scgf/service_icon2.png"),
            },
            {
              id: "023",
              name: "成熟的关联引用体系",
              icon: require("@/assets/images/index/s_fwal/scgf/service_icon3.png"),
            },
            {
              id: "024",
              name: "上下游数据响应机制",
              icon: require("@/assets/images/index/s_fwal/scgf/service_icon4.png"),
            },
          ],
        },
        {
          id: "03",
          img: require("@/assets/images/index/s_fwal/hsj/services_bg.png"),
          itemList: [
            {
              id: "031",
              name: "以民航底层大数据为依托",
              icon: require("@/assets/images/index/s_fwal/hsj/service_icon1.png"),
            },
            {
              id: "032",
              name: "可视化、模块化展现方式",
              icon: require("@/assets/images/index/s_fwal/hsj/service_icon2.png"),
            },
            {
              id: "033",
              name: "个性化研发设计满足差异化用户需求",
              icon: require("@/assets/images/index/s_fwal/hsj/service_icon3.png"),
            },
            {
              id: "034",
              name: "提供一站式、可定制化的数据综合服务",
              icon: require("@/assets/images/index/s_fwal/hsj/service_icon4.png"),
            },
          ],
        },
      ];
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/services.css";
</style>
<style lang="less" scoped>
.services /deep/.nav-item {
  font-size: 16px !important;
  font-family: "PingFang Bold";
  color: rgb(51, 51, 51);
  line-height: 2.05;
}
.services /deep/.nav-tabs .nav-link.active {
  color: rgb(6, 107, 243) !important;
  background-color: #fff;
  border-color: rgb(6, 107, 243) !important;
}
.services .nav-tabs .nav-item .active {
  border-bottom: 1px rgb(6, 107, 243) !important;
}
.services /deep/.nav-tabs .nav-link {
  border: 1px solid #bfbfbf;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 0;
  margin: 0;
}
.services /deep/.nav .nav-item a {
  height: 100%;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 575px) {
  .services {
    height: auto;
    /* margin-top: 140%; */
  }
  .services .tabs-box {
    width: 100% !important;
  }
  .services /deep/.nav-item {
    font-size: 12px !important;
  }
  .services /deep/.nav-tabs .nav-link {
    padding: 5px 0;
  }
  .services {
    height: auto;
  }
  .bg-item {
    width: 80%;
  }
  .tabs-box {
    width: 100% !important;
  }

  .right_c span {
    font-size: 15px;
    line-height: 2.3;
  }
  .btns span {
    display: inline-block;
    width: 100px;
    font-size: 12px;
  }
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .services /deep/.nav-item {
    font-size: 13px !important;
  }
  .services {
    height: auto;
  }

  .bg-item {
    width: 70%;
  }
  .services .tabs-box {
    width: 100% !important;
  }

  .right_c span {
    font-size: 16px;
    line-height: 2.5;
  }
  .btns span {
    display: inline-block;
    width: 120px;
    font-size: 13px;
  }
}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991px) {
  .services /deep/.nav-item {
    font-size: 14px !important;
  }
  .services {
    height: auto;
  }

  .bg-item {
    width: 80%;
  }
  .services .tabs-box {
    width: 100% !important;
  }

  .right_c span {
    font-size: 17px;
    line-height: 2.8;
  }
  .btns span {
    display: inline-block;
    width: 130px;
    font-size: 14px;
  }
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199px) {
  .services {
    height: calc(800px * 0.75);
  }
  .fuwu-wrap {
    margin-top: 4%;
    margin-bottom: 3%;
  }
  .fuwu {
    margin-bottom: 14%;
  }
  .bg-item {
    width: 90%;
    margin: 0 auto 20px;
  }
  .services /deep/.nav-item {
    font-size: 15px !important;
  }
  .right_c span {
    font-size: 17px;
    line-height: 2.8;
  }
  .btns span {
    display: inline-block;
    width: 130px;
    font-size: 14px;
  }
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) and (max-width: 1680px) {
  .services {
    height: calc(800px * 0.85);
  }
  .fuwu-wrap {
    margin-top: 4%;
    margin-bottom: 3%;
  }
  .fuwu {
    margin-bottom: 16%;
  }
  .bg-item {
    width: 90%;
    margin: 0 auto 20px;
  }
}
@media (min-width: 1681px) and (max-width: 1980px) {
  .services {
    height: calc(800px * 0.9);
  }
  .fuwu-wrap {
    margin-top: 3%;
    margin-bottom: 3%;
  }
  .fuwu {
  }
  .bg-item {
    width: 80%;
    margin: 0 auto 20px;
  }
}
@media (min-width: 1981px) and (max-width: 2048px) {
  .services {
    height: calc(800px);
  }
  .fuwu-wrap {
    margin-top: 5%;
    margin-bottom: 5%;
  }
  .fuwu {
  }
  .bg-item {
    width: 85%;
    margin: 0 auto 20px;
  }
}
@media (min-width: 2049px) and (max-width: 3000px) {
  .services {
    height: calc(850px);
  }
  .fuwu-wrap {
    margin-top: 3%;
    margin-bottom: 3%;
  }
  .bg-item {
    width: 60%;
    margin: 0 auto 20px;
  }
}
@media (min-width: 3001px) {
  .services {
    height: calc(900px);
  }
  .fuwu-wrap {
    margin-top: 3%;
    margin-bottom: 3%;
  }
  .bg-item {
    width: 60%;
    margin: 0 auto 20px;
  }
}
</style>
